import React from 'react';

const EmptySidebar = () => <div />;

export default EmptySidebar;
